import React, {FC} from 'react';
import Modal from 'react-bootstrap/Modal';
import {ReportModal} from 'components/ReportModal';

import {Options} from './Options';
import {useState} from './useState';

import * as styles from './styles.module.scss';

type SampleModalProps = {
	onHide: () => void;
}

export const SampleModal: FC<SampleModalProps> = ({onHide}) => {
	const [state, dispatch] = useState();
	return (
		<ReportModal sample cache={state.current.id} onHide={onHide}>
			<Modal.Header closeButton className={styles.header}>
				See: <Options
					state={state}
					dispatch={dispatch}
				/>
			</Modal.Header>
		</ReportModal>
	);
};
